module.exports = __webpack_public_path__ + "static/media/wallet-animate.77bd2d72.svg";